/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutor_Error_Notfound1Inputs */

const en_tutor_error_notfound1 = /** @type {(inputs: Tutor_Error_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not found`)
};

const fr_tutor_error_notfound1 = /** @type {(inputs: Tutor_Error_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`page introuvable`)
};

/**
* | output |
* | --- |
* | "not found" |
*
* @param {Tutor_Error_Notfound1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const tutor_error_notfound1 = /** @type {((inputs?: Tutor_Error_Notfound1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutor_Error_Notfound1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tutor_error_notfound1(inputs)
	return fr_tutor_error_notfound1(inputs)
});
export { tutor_error_notfound1 as "tutor_error_notFound" }